import React from "react";
import Dropdown from "components/dropdown";
import { FiAlignJustify } from "react-icons/fi";
import { Link } from "react-router-dom";
// import navbarimage from "assets/img/layout/Navbar.png";
// import { BsArrowBarUp } from "react-icons/bs";
import { FaRegUserCircle } from "react-icons/fa";
// import { FiSearch } from "react-icons/fi";
// import { AiOutlineShoppingCart } from "react-icons/ai";
// import { CgMenuGridO } from "react-icons/cg";
import {
  IoMdNotificationsOutline,
  // IoMdInformationCircleOutline,
} from "react-icons/io";
// import avatar from "assets/img/avatars/avatar4.png";
import { useAuth } from "App";
import jwtDecode from "jwt-decode";
import { GET_USER_BY_ID } from "graphql/auth/queries";
import { useQuery } from "@apollo/client";
import { GET_NOTIFICATIONS_QUERY } from "graphql/notifications/queries";

const Navbar = (props) => {
  const { onOpenSidenav, brandText } = props;
  // const [darkmode, setDarkmode] = React.useState(false);
  const { onLogout, token } = useAuth();
  const user = jwtDecode(token);
  // console.log("User: ", user);

  const { loading, error, data } = useQuery(GET_USER_BY_ID, {
    variables: { id: user.sub }, // Replace with the domain you want to query
  });
  // console.log("GraphQL Query:", GET_USER_BY_ID?.loc?.source?.body);

  const {
    loading: loadingGetNotifications,
    error: errorGetNotifications,
    data: dataGetNotifications,
  } = useQuery(GET_NOTIFICATIONS_QUERY, {
    variables: { userId: user.sub }, // Replace with the domain you want to query
  });

  if (loading || loadingGetNotifications) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;
  if (errorGetNotifications)
    return <p>Error: {errorGetNotifications.message}</p>;

  // console.log("Sangat Parshada: ", data);
  // useEffect(() => {
  //   setVerifyDomainOwnershipData(verifyDomainOwnershipData.verifyDomainOwnership)

  //   return <div> {verifyDomainOwnershipData.map((val) => {
  //     console.log(val);
  //   })}
  //   </div>
  // }, [verifyDomainOwnershipData])

  // console.log(dataGetNotifications.getNotifications);

  const handleLogoutClick = () => {
    // Call the handleLogout function when the logout button is clicked
    onLogout();
  };

  return (
    <nav className="sticky top-4 z-20 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/10 p-2 backdrop-blur-xl dark:bg-[#0b14374d]">
      <div className="ml-[6px]">
        <div className="mt-4 h-6 w-[224px] pt-1 md:mt-0">
          <a
            className="text-sm font-normal text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            href=" "
          >
            Pages
            <span className="mx-1 text-sm text-navy-700 hover:text-navy-700 dark:text-white">
              {" "}
              /{" "}
            </span>
          </a>
          <Link
            className="text-sm font-normal capitalize text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            to="#"
          >
            {brandText}
          </Link>
        </div>
        <p className="shrink text-[33px] capitalize text-navy-700 dark:text-white">
          <Link
            to="#"
            className="font-bold capitalize hover:text-navy-700 dark:hover:text-white"
          >
            {brandText}
          </Link>
        </p>
      </div>

      {/* <div className="relative mt-[3px] flex flex-grow items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:flex-grow-0 md:gap-1 xl:gap-2"> */}
      <div className="relative mt-[3px] flex  items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:flex-grow-0 md:gap-1 xl:gap-2">
        {/* <div className="flex h-full items-center rounded-full bg-lightPrimary text-navy-700 dark:bg-navy-900 dark:text-white xl:w-[225px]">
          <p className="pl-3 pr-2 text-xl">
            <FiSearch className="h-4 w-4 text-gray-400 dark:text-white" />
          </p>
          <input
            type="text"
            placeholder="Search..."
            className="block h-full w-full rounded-full bg-lightPrimary text-sm font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white sm:w-fit"
          />
        </div> */}
        <span
          className="flex cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden"
          onClick={onOpenSidenav}
        >
          <FiAlignJustify className="h-5 w-5" />
        </span>
        {/* <p className="cursor-pointer">
          <IoMdNotificationsOutline className="h-4 w-4 text-gray-600 dark:text-white" />
        </p> */}
        {/* <Dropdown
          button={
            <p className="cursor-pointer">
              <IoMdNotificationsOutline className="h-4 w-4 text-gray-600 dark:text-white" />
            </p>
          }
          animation="origin-[65%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
          children={
            <div className="flex w-[360px] flex-col gap-3 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none sm:w-[460px]">
              <div className="flex items-center justify-between">
                <p className="text-base font-bold text-navy-700 dark:text-white">
                  Notification
                </p>
              </div>
              {dataGetNotifications.getNotifications.map((notification, index) => {
                return (
                  <button className="flex w-full items-center" key={index}>
                    <div className="ml-2 flex h-full w-full flex-col justify-center rounded-lg px-1 text-sm">
                      <p className="mb-1 text-left text-base font-bold text-gray-900 dark:text-white">
                        {notification.title}
                      </p>
                      <p className="font-base text-left text-xs text-gray-900 dark:text-white">
                        {notification.message}
                      </p>
                    </div>
                  </button>
                )
              })}
            </div>
          }
          classNames={"py-2 top-4 -left-[230px] md:-left-[440px] w-max"}
        /> */}
        {/*shopping cart*/}
        {/* <p className="cursor-pointer">
          <AiOutlineShoppingCart className="h-4 w-4 text-gray-600 dark:text-white" />
        </p> */}
        {/* <Dropdown
          button={
            <p className="cursor-pointer">
              <AiOutlineShoppingCart className="h-4 w-4 text-gray-600 dark:text-white" />
            </p>
          }
          children={
            <div className="flex w-[350px] flex-col gap-2 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div
                style={{
                  backgroundImage: `url(${navbarimage})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                }}
                className="mb-2 aspect-video w-full rounded-lg"
              />
              <a
                target="blank"
                href="https://horizon-ui.com/pro?ref=live-free-tailwind-react"
                className="px-full linear flex cursor-pointer items-center justify-center rounded-xl bg-brand-500 py-[11px] font-bold text-white transition duration-200 hover:bg-brand-600 hover:text-white active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:bg-brand-200"
              >
                Buy Horizon UI PRO
              </a>
              <a
                target="blank"
                href="https://horizon-ui.com/docs-tailwind/docs/react/installation?ref=live-free-tailwind-react"
                className="px-full linear flex cursor-pointer items-center justify-center rounded-xl border py-[11px] font-bold text-navy-700 transition duration-200 hover:bg-gray-200 hover:text-navy-700 dark:!border-white/10 dark:text-white dark:hover:bg-white/20 dark:hover:text-white dark:active:bg-white/10"
              >
                See Documentation
              </a>
              <a
                target="blank"
                href="https://horizon-ui.com/?ref=live-free-tailwind-react"
                className="hover:bg-black px-full linear flex cursor-pointer items-center justify-center rounded-xl py-[11px] font-bold text-navy-700 transition duration-200 hover:text-navy-700 dark:text-white dark:hover:text-white"
              >
                Try Horizon Free
              </a>
            </div>
          }
          classNames={"py-2 top-6 -left-[250px] md:-left-[330px] w-max"}
          animation="origin-[75%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
        /> */}

        {/* menu */}
        {/* <Dropdown
          button={
            <p className="cursor-pointer">
              <CgMenuGridO className="h-4 w-4 text-gray-600 dark:text-white" />
            </p>
          }
          children={
            <div className="flex w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div className="p-4">
                <div className="flex items-center gap-2">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    👋 Hey, Adela
                  </p>{" "}
                </div>
              </div>
              <div className="h-px w-full bg-gray-200 dark:bg-white/20 " />

              <div className="flex flex-col p-4">
                <a
                  href=" "
                  className="text-sm text-gray-800 dark:text-white hover:dark:text-white"
                >
                  Domains
                </a>
                <a
                  href=" "
                  className="mt-3 text-sm text-gray-800 dark:text-white hover:dark:text-white"
                >
                  Website
                </a>
                <a
                  href=" "
                  className="mt-3 text-sm text-gray-800 dark:text-white hover:dark:text-white"
                >
                  Hosting Wordpress
                </a>
              </div>
            </div>
          }
          classNames={"py-2 top-8 -left-[180px] w-max"}
        /> */}
        {/* <div
          className="cursor-pointer text-gray-600"
          onClick={() => {
            if (darkmode) {
              document.body.classList.remove("dark");
              setDarkmode(false);
            } else {
              document.body.classList.add("dark");
              setDarkmode(true);
            }
          }}
        >
          {darkmode ? (
            <RiSunFill className="h-4 w-4 text-gray-600 dark:text-white" />
          ) : (
            <RiMoonFill className="h-4 w-4 text-gray-600 dark:text-white" />
          )}
        </div> */}
        {/* Profile & Dropdown */}
        <Dropdown
          button={
            // <img
            //   className="h-10 w-10 rounded-full"
            //   src={avatar}
            //   alt="Elon Musk"
            // />
            <p className="cursor-pointer">
              <FaRegUserCircle className="h-4 w-4 text-gray-600 dark:text-white" />
            </p>
          }
          children={
            <div className="flex w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div className="p-4">
                <div className="flex items-center gap-2">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    👋 Hey,{" "}
                    {data.getUserById.first_name +
                      " " +
                      data.getUserById.last_name}
                  </p>{" "}
                </div>
                {user.roles.includes("Admin") ? (
                  ""
                ) : (
                  <div className="flex items-center gap-2">
                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                      Merchant ID: {data.getUserById.merchant_id}
                    </p>{" "}
                  </div>
                )}
              </div>
              <div className="h-px w-full bg-gray-200 dark:bg-white/20 " />

              <div className="flex flex-col p-4">
                {/* <a
                  href=" "
                  className="text-sm text-gray-800 dark:text-white hover:dark:text-white"
                >
                  Exit Afternic Beta
                </a> */}
                <Link
                  to="/portfolio/my_account"
                  className="mt-3 text-sm text-gray-800 dark:text-white hover:dark:text-white"
                >
                  Account Settings
                </Link>
                <a
                  href="https://domaincook.com/pages/contact"
                  className="mt-3 text-sm text-gray-800 dark:text-white hover:dark:text-white"
                  target="_blank"
                  rel="noreferrer"
                >
                  Contact Us
                </a>
                <a
                  href="https://domaincook.com/pages/seller-registration#FAQs"
                  className="mt-3 text-sm text-gray-800 dark:text-white hover:dark:text-white"
                  target="_blank"
                  rel="noreferrer"
                >
                  FAQ
                </a>
                <button
                  onClick={handleLogoutClick}
                  className="mt-3 text-sm font-medium text-red-500 hover:text-red-500"
                >
                  Sign Out
                </button>
              </div>
            </div>
          }
          classNames={"py-2 top-8 -left-[180px] w-max"}
        />
      </div>
    </nav>
  );
};

export default Navbar;
